import type { IconPrimitives, IconProps } from './types';

export const buildCameraIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  CameraCloseIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 40 40' fill='none' {...props}>
      <Path d='M9.39331 9.39331L30.6066 30.6066M9.39331 30.6066L30.6066 9.39331' stroke={color} strokeLinejoin='round' />
    </Svg>
  ),
  FlipCameraIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M20.71 3L20.41 5.55L20.11 8.1L17.41 7.55L14.71 7M3.29 21L3.59 18.45L3.89 15.9L6.59 16.45L9.29 17' stroke={color} strokeLinecap='square' />
      <Path
        d='M21 11.9977C20.9995 14.0367 20.3066 16.015 19.035 17.6088C17.7633 19.2025 15.9881 20.3172 14.0001 20.7704C12.0122 21.2235 9.92928 20.9882 8.09254 20.1029C6.25579 19.2177 4.77406 17.735 3.89 15.8977M20.11 8.09772C19.2259 6.26041 17.7442 4.77773 15.9075 3.8925C14.0707 3.00727 11.9878 2.77195 9.99987 3.22507C8.01192 3.6782 6.23674 4.79292 4.96505 6.38668C3.69336 7.98044 3.00052 9.95878 3 11.9977'
        stroke={color}
        strokeLinejoin='round'
      />
    </Svg>
  ),
  UploadFromDeviceIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M16.2 7.6L14.1 5.3L12 3L9.9 5.3L7.8 7.6' stroke={color} strokeLinecap='square' />
      <Path d='M12 16.5V3' stroke={color} />
      <Path d='M4 14V20H20V14' stroke={color} />
    </Svg>
  ),
  DeletePhotoIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M3 6.28655H20M4.87791 6.28655V21C7.05242 21 13.4768 21 18.1221 21V6.28655M9.52326 11.655L11.5 13.6433M11.5 13.6433L13.4767 15.6316M11.5 13.6433L13.4767 11.655M11.5 13.6433L9.52326 15.6316M8.93023 6.28655V4C9.52335 4 13.4768 4 14.0698 4V6.28655'
        stroke={color}
      />
    </Svg>
  ),
});
